import styled from 'styled-components';

import vw_text from '@/assets/fonts/VWText.woff';
import vw_textLight from '@/assets/fonts/VWText-Light.woff';
import vw_head from '@/assets/fonts/VWHead.woff';
import vw_headLight from '@/assets/fonts/VWHead-Light.woff';
import vw_headBold from '@/assets/fonts/VWHead-Bold.woff';
import vw_textBold from '@/assets/fonts/VWText-Bold.woff';
const screenHeight = window.innerHeight;
export const STDStyle = styled.div`
  @font-face {
    font-family: 'vw-text';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_text}') format('woff');
  }
  @font-face {
    font-family: 'vw-text-light';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_textLight}') format('woff');
  }
  @font-face {
    font-family: 'vw-text-bold';
    font-style: normal;
    font-weight: bold;
    src: url('${vw_textBold}') format('woff');
  }

  @font-face {
    font-family: 'vw-head';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_head}') format('woff');
  }
  @font-face {
    font-family: 'vw-head-light';
    font-style: normal;
    font-weight: 200;
    src: url('${vw_headLight}') format('woff');
  }
  @font-face {
    font-family: 'vw-head-bold';
    font-style: normal;
    font-weight: bold;
    src: url('${vw_headBold}') format('woff');
  }
  * {
    box-sizing: border-box;
  }

  --font-family-head: vw-head, Helvetica, Arial, sans-serif;
  --font-family-text: vw-text, Helvetica, Arial, sans-serif;
  --font-family-text-light: vw-text-light, Helvetica, Arial, sans-serif;
  --font-family-head-light: vw-head-light, Helvetica, Arial, sans-serif;
  --font-family-text-bold: vw-text-bold, Helvetica, Arial, sans-serif;
  --font-family-head-bold: vw-head-bold, Helvetica, Arial, sans-serif;

  font-family: var(--font-family-text);
  -webkit-font-smoothing: antialiased;
  --size-grid001: 4.16vw;
  --size-grid002: 8.33vw;
  --size-grid003: 12.5vw;
  --size-grid004: 16.66vw;
  --size-grid005: 20.83vw;
  --size-grid006: 25vw;
  --size-grid007: 29.16vw;
  --size-grid008: 33.33vw;
  --size-grid009: 37.5vw;
  --size-grid010: 41.66vw;
  --size-grid011: 45.83vw;
  --size-grid012: 50vw;
  --size-grid013: 54.16vw;
  --size-grid014: 58.33vw;
  --size-grid015: 62.5vw;
  --size-grid016: 66.66vw;
  --size-grid017: 70.83vw;
  --size-grid018: 75vw;
  --size-grid019: 79.16vw;
  --size-grid020: 83.33vw;
  --size-grid021: 87.5vw;
  --size-grid022: 91.66vw;
  --size-grid023: 95.83vw;
  --size-grid024: 100vw;
  --size-dynamic0020: 4px;
  --size-dynamic0040: 12px;
  --size-dynamic0050: 12px;
  --size-dynamic0100: 20px;
  --size-dynamic0120: 24px;
  --size-dynamic0130: 24px;
  --size-dynamic0140: 28px;
  --size-dynamic0150: 28px;
  --size-dynamic0200: 32px;
  --size-dynamic0250: 44px;
  --size-dynamic0270: 56px;
  --size-dynamic0300: 72px;
  --size-dynamic0350: 100px;
  --size-dynamic0450: 156px;

  @media (min-width: 560px) {
    --size-dynamic0020: 4px;
    --size-dynamic0040: 20px;
    --size-dynamic0050: 20px;
    --size-dynamic0100: 24px;
    --size-dynamic0120: 20px;
    --size-dynamic0130: 40px;
    --size-dynamic0140: 32px;
    --size-dynamic0150: 52px;
    --size-dynamic0200: 56px;
    --size-dynamic0250: 68px;
    --size-dynamic0270: 80px;
    --size-dynamic0300: 96px;
    --size-dynamic0350: 132px;
    --size-dynamic0450: 172px;
  }
  @media (min-width: 1600px) {
    --size-dynamic0020: 8px;
    --size-dynamic0040: 32px;
    --size-dynamic0050: 24px;
    --size-dynamic0100: 28px;
    --size-dynamic0120: 20px;
    --size-dynamic0130: 52px;
    --size-dynamic0140: 48px;
    --size-dynamic0150: 64px;
    --size-dynamic0200: 72px;
    --size-dynamic0250: 84px;
    --size-dynamic0270: 100px;
    --size-dynamic0300: 120px;
    --size-dynamic0350: 196px;
    --size-dynamic0450: 184px;
  }
`;
export const StdDivInitial = styled.div`
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const StdMain = styled.div`
  flex: 1;
`;
export const StdTop = styled.div` 
  position: sticky;
  top: 0;
  z-index: 2;
`;
export const StdBody = styled.div`
  display: block;
`;

export const StdFooter = styled.div`
 display: block;
 height: 200;
`;
